
import HeatMapPage from '@/pages/clients/HeatMapPage.vue';
import MTActiveClientsPage from '@/pages/clients/MTActiveClientsPage.vue';
import UserActionLogsPage from '@/pages/logs/UserActionLogsPage.vue';
import ReceiptsPage from '@/pages/transactions/ReceiptsPage.vue';
import RemittancePage from '@/pages/transactions/RemittancePage.vue';
import CashflowPage from '@/pages/users/CashflowPage.vue';
import UsersPage from '@/pages/users/UsersPage.vue';
import { hasRoles, isAuthenticated } from '@/utils/auth';
import { createRouter, createWebHistory } from 'vue-router';
const HomePage = () => import('@/pages/HomePage.vue');
const NotFound = () => import('@/pages/NotFound.vue');
const ForbiddenPage = () => import('@/pages/ForbiddenPage.vue');
const LoginPage = () => import('@/pages/LoginPage.vue')
const ClientsPage = () => import('@/pages/clients/ClientsPage.vue')
const routes = [
    {
        path: '/',
        name: 'home',
        component: HomePage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },
    {
        path: '/',
        name: 'dashboard',
        component: HomePage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },
    {
        path: '/clients/all',
        name: 'clients-all',
        component: ClientsPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },
    {
        path: '/clients/mt-active',
        name: 'clients-mt-active',
        component: MTActiveClientsPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },
    {
        path: '/clients/heatmap',
        name: 'clients-heatmap',
        component: HeatMapPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },

    {
        path: '/users/list',
        name: 'users-list',
        component: UsersPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },
    {
        path: '/users/cashflow',
        name: 'users-cashflow',
        component: CashflowPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },

    {
        path: '/transactions/receipts',
        name: 'transactions-receipts',
        component: ReceiptsPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },
     {
        path: '/transactions/remittances',
        name: 'transactions-remittances',
        component: RemittancePage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },

    {
        path: '/system/user-action-logs',
        name: 'user-action-logs',
        component: UserActionLogsPage,
        meta: { requiresAuth: true, showHeader: true, roles: ['teller', 'tech', 'treasurer', 'admin', 'it'] }
    },

    {
        path: '/login',
        name: 'login',
        component: LoginPage,
        // meta: { requiresAuth: true, showHeader: true, roles: roles.adminDashboardRoles }
    },
    {
        path: '/forbidden',
        name: 'forbidden',
        component: ForbiddenPage,
    },
    { path: '/:catchAll(.*)', component: NotFound, meta: { showHeader: false } }
]
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { el: to.hash };
        }
        return savedPosition || { top: 0 };
    }
});
router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'Exodous Admin'; // Fallback if no title
    const isAuthed = isAuthenticated(); // Implement your authentication check
    // Redirect to login if route requires auth and user is not authenticated
    if (to.meta.requiresAuth && !isAuthed) {
        return next({ name: 'login', query: { redirect: to.fullPath } })
    }

    // Redirect away from auth pages if already logged in
    if (to.meta.requiresGuest && isAuthed) {
        return next({ name: 'dashboard' })
    }

    if (to.path === '/login' && isAuthed)
        return next({ name: 'dashboard' });

    // Handle role-based access control
    if (to.meta.roles && to.meta.roles.length > 0) {
        const hasAccess = hasRoles(to.meta.roles); // Example function to get user roles
        // Check if any of the user's roles match the allowed roles

        if (!hasAccess) {
            // Redirect to unauthorized page or handle unauthorized access
            return next('/forbidden'); // Example redirect to unauthorized page
        }
    }

    next()
})



export default router;
